import styled from 'styled-components';

export const Base = styled.div<{ $highlight?: boolean }>`
	background: ${(p) => p.theme.gray[0]};
	padding: 24px;
	border-radius: 12px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
	transition: all 0.2s ease-in-out;
	border: 2px solid transparent;
	overflow: hidden;

	${(p) =>
		p.$highlight &&
		`
		border-color: ${p.theme.blue[400]};
		background: linear-gradient(135deg, ${p.theme.gray[0]}, ${p.theme.blue[300]}30);
	`}
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 16px;
`;

export const Icon = styled.div<{ $iconColor: string }>`
	width: 40px;
	height: 40px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	background: ${(p) => `${p.$iconColor}20`};
	color: ${(p) => p.$iconColor};
`;

export const Label = styled.span`
	font-size: 14px;
	font-weight: 500;
	color: ${(p) => p.theme.gray[600]};
`;

export const Amount = styled.div`
	padding-top: 8px;
	font-size: 36px;
	font-weight: 700;
	color: ${(p) => p.theme.gray[1000]};
	margin-bottom: 8px;
`;

export const Subtext = styled.div`
	font-size: 12px;
	color: ${(p) => p.theme.gray[400]};
`;

export const ButtonWrapper = styled.div`
	margin-top: 16px;
`;
